import type { ListQuery } from "client/api/common/ListQuery";
import axiosClient from "../axios-client";
import type { EntityDto } from "./EntityDto";
import type { ListEntitiesResponse } from "./ListEntitiesResponse";

const BASE_URL = "roles";

export interface RoleDto extends EntityDto {
  id: string;
  name: string;
  description: string;
  roleType: RoleType;
}

export type RoleType = "CloudSubscription" | "SubscriptionGroup" | "ServerLicense";

export type GetRolesResponse = ListEntitiesResponse<RoleDto>;

export const getRoles = async (query?: ListQuery): Promise<GetRolesResponse> => {
  const response = await axiosClient.get<GetRolesResponse>(BASE_URL, {
    params: query,
  });
  return response.data;
};
